import {
  getHeadlessUrl,
  NavigationType,
} from '@wix/wix-to-headless-redirect-client';
import { EcomPlatformViewerScriptContext } from '../../viewer-script/types';
import { PageMap } from '@wix/wixstores-client-core';

export const toCart =
  ({
    context,
    origin,
  }: {
    context: EcomPlatformViewerScriptContext;
    origin: string;
  }) =>
  (): Promise<void> => {
    const headlessUrl = getHeadlessUrl({
      query: context.siteStore.location.query,
      baseUrl: context.siteStore.location.baseUrl,
      navParams: { logicalName: NavigationType.ECOM_CART },
    });

    if (headlessUrl) {
      context.siteStore.navigateToLink({
        url: headlessUrl,
        sdkLink: {
          url: headlessUrl,
          target: '_top',
          type: 'ExternalLink',
        },
      });
      return Promise.resolve();
    }

    return context.siteStore.navigate(
      {
        sectionId: PageMap.CART,
        queryParams: { origin },
      },
      true,
    );
  };
